/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable no-mixed-operators */

import React, { useState, useEffect } from 'react';
import { Form, Input } from 'semantic-ui-react';
import { apiV2Server } from '../../config';
import { Loading } from '../../components/GUI/Loading';
import { isValidXLT } from '../../helpers/tools';
import * as Sentry from "@sentry/browser";

const Tracking = (props) => {
  const [submitted, setSubmitted] = useState(false);
  const [xltID, setXltID] = useState('');
  const [statusHistory, setStatusHistory] = useState(null);

  useEffect(() => {
    setXltID(props.match.params.xltID);
    fetchTrackingData();
  }, []);

  const fetchTrackingData = () => {
    if (xltID) {
      setStatusHistory(null);
      setSubmitted(true);
      fetch(`${apiV2Server}parcels/tracking/${xltID}`)
        .then((res) => res.json().then((data) => {
          setStatusHistory(data.statusHistory || []);
          setSubmitted(false);
        }))
        .catch((e) => {
          console.log('Error fetching tracking data', e);
          Sentry.captureException(e);
          setSubmitted(false);
        });
    }
  };

  const handleTrackingCodeChange = (e, { value }) => {
    setXltID(value);
  };

  return (
    <>
      <div className='trackingInfo'>
        <h1 className='title text-center'>Track Your Shipment</h1>
        <Form className='sms-form rtl' onSubmit={fetchTrackingData} style={{ margin: '35px' }}>
          <Form.Field>
            <label htmlFor='xltID'>Tracking code</label>
            <Input type='xltID' name='xltID' required placeholder='Enter tracking number' id='xltID' value={xltID} onChange={handleTrackingCodeChange} style={{ direction: 'ltr' }} />
          </Form.Field>
          <div className='centered'>
            <button className='btn medium orange' type='submit' disabled={submitted || !isValidXLT(xltID)}>Track</button>
          </div>
        </Form>
        { submitted && !statusHistory && <Loading /> }
        { statusHistory &&
          (statusHistory.length &&
            <div className='animated fadeIn'>
              <h3 className='title bold text-center'> Tracking Information:</h3>
              <ul className='box'>
                { statusHistory.length && statusHistory.map(status =>
                  <li key={status.date}>
                    <span className='timestamp'>{status.date}</span>
                    <span className='status'>{status.statusText}</span>
                  </li>
                )}
              </ul>
            </div>
            || <h3 className='bold text-center'>No results found</h3>
          )
        }
      </div>
      <div id='trackingContact' className='text-center'>
        We are proud to ship your orders <br />
        Exelot - It's quick, reliable and affordable!
        <div className='contact-details'>
          <div className='bold'>לעמוד התמיכה באתר אקסלוט - לחץ <a href='https://exelot.com/support/?lang=he'>כאן</a></div>
        </div>
      </div>
    </>
  );
};

export default Tracking;
